import {Component, HostListener, OnInit} from '@angular/core';
import {DefaultMeasurementType} from "../../../model/default-measurement-type";
import {DefaultMeasurementTypeFilters} from "../../../model/filters/default-measurement-type-filters";
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {FiltersService} from "../../../services/filters.service";
import {SortOrder} from "../../../model/sort-order";
import {DefaultMeasurementTypesService} from "../../../services/default-measurement-types.service";
import {SelectItem} from "primeng/api";
import {DataType} from "../../../model/data-type";

@Component({
  selector: 'app-default-measurement-types',
  templateUrl: './default-measurement-types.component.html',
  styleUrls: ['./default-measurement-types.component.scss']
})
export class DefaultMeasurementTypesComponent implements OnInit {

  public types: DefaultMeasurementType[];
  public totalTypes: number;
  public loadingTypes: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];
  public dataTypes: SelectItem[];

  public filtersVisible: boolean;
  public currentFilters: DefaultMeasurementTypeFilters;
  public filtersFilled: boolean;

  constructor(private defaultMeasurementTypesService: DefaultMeasurementTypesService,
              private i18n: TranslocoService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DefaultMeasurementTypeFilters>) {
    this.dataTypes = [
      {label: 'forms.sensorType.STRING', value: DataType.STRING},
      {label: 'forms.sensorType.NUMBER', value: DataType.NUMBER},
      {label: 'forms.sensorType.BOOLEAN', value: DataType.BOOLEAN},
      {label: 'forms.sensorType.COORDINATES', value: DataType.COORDINATES},
      {label: 'forms.sensorType.ANALOG_SIGNAL', value: DataType.ANALOG_SIGNAL},
      {label: 'forms.sensorType.DIGITAL_SIGNAL', value: DataType.DIGITAL_SIGNAL}
    ];
    this.currentFilters = new DefaultMeasurementTypeFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.types = new Array(this.rows);
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
  }

  private loadTypes(offset: number, limit: number): void {
    this.loadingTypes = true;
    this.types = new Array(this.rows);
    this.selected = [];
    this.defaultMeasurementTypesService.getDefaultMeasurementTypes(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.types = response.defaultMeasurementTypes;
        this.totalTypes = response.totalElements;
        this.loadingTypes = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadTypes(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DefaultMeasurementTypeFilters();
    this.currentFilters.sortField = 'sensor';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadTypes(this.first / this.rows, this.rows);
  }

  confirmAndDelete(type: DefaultMeasurementType): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteType(type.sensor, type.unit);
    });
  }

  deleteType(sensor: string, unit: string): void {
    this.defaultMeasurementTypesService.deleteDefaultMeasurementType(sensor, unit).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTypes(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const identifiers = this.selected.map(item => ({sensor: item.sensor, unit: item.unit}));

    this.defaultMeasurementTypesService.deleteDefaultMeasurementTypes(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTypes(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
